import React from 'react';
import './VenueDetails.css';

import { Heading } from '../../components';
import { venue } from '../../constants';



const VenueDetails = () => {

  return (
    // Venue Information Section
    <section className="venue-details">

      <div className='box-container'>

        <div className="venue-info">

          <Heading title={venue.venueInfo.heading} subTitle={venue.venueInfo.sub} sideHeading linear />

          {/* Venue Info Points */}
          <ul className="venue-points">
            {venue.venueInfo.points.map((point, index) => (
              <li key={index}>
                <div className="icon">{point.icon}</div>
                <div className="text">
                  <h5>{point.title}</h5>
                  <p>{point.description}</p>
                </div>
              </li>
            ))}
          </ul>

        </div>

        <iframe
          src={venue.googleMap.src}
          style={{ border: 0 }}
          allowFullScreen={venue.googleMap.allowFullScreen}
          loading={venue.googleMap.loading}
          title="Venue Location"
        ></iframe>

      </div>

    </section>
  );
};

export default VenueDetails;